import React from 'react';
import './style.css';

const uploadImg = 'https://res.cloudinary.com/cardclan-io/image/upload/v1616675350/upload_xtfk5f.png';

interface Props {
	handleImageUpload: (event: any) => void;
	handleGenerateWithAIClick: (event: any) => void;
}

const ImagePicker = ({ handleImageUpload, handleGenerateWithAIClick }: Props) => {
	return (
		<div
			style={{ height: '206px', width: '146px' }}
			className="rounded-lg shadow-md flex flex-col justify-between bg-white overflow-hidden"
		>
			{/* Upload Section */}
			<div className="relative flex-grow flex items-center justify-center p-2 cursor-pointer hover:bg-gray-50 transition-colors duration-200">
				<div className="text-center">
					<img className="text-grey block m-auto " height={30} width={30} src={uploadImg} alt="logo" />
					<p className=" text-sm text-black mt-2">Upload Cover</p>
					<p className="text-mineShaft capitalize text-xs">{'( 320x458 pixels )'}</p>
				</div>
				<input
					accept="image/*"
					onChange={handleImageUpload}
					type="file"
					className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
				/>
			</div>

			{/* Divider */}
			<div className="border-t border-gray-200"></div>

			{/* Generate with AI Section */}
			<button
				onClick={handleGenerateWithAIClick}
				className="w-full text-center py-3 text-sm font-medium text-indigo-600 hover:bg-indigo-50 transition-colors duration-200 focus:outline-none"
			>
				✨ Generate with AI
			</button>
		</div>
	);
};

export default ImagePicker;
